// Credits go to: https://raptis.wtf/blog/create-a-navbar-with-chakra-ui-react/

import React from "react";
import {
  Box,
  Button,
  Flex,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spacer,
  Text,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";
import { AiFillLinkedin, AiFillGithub, AiOutlineHome } from "react-icons/ai";
import { GiHamburgerMenu } from "react-icons/gi";
import { HiOutlineMoon, HiOutlineSun } from "react-icons/hi";
import { VscFeedback } from "react-icons/vsc";
import { useNavigate } from "react-router-dom";
import ReactGa from "react-ga";

export const NavigationBar = (props: JSX.IntrinsicAttributes) => {
  const { toggleColorMode } = useColorMode();
  const bgColor = useColorModeValue("gray.50", "whiteAlpha.50");
  let navigate = useNavigate();

  const onClickHomeButton = () => {
    ReactGa.event({
      category: "Button",
      action: "Home",
    });
    navigate("/");
  };

  const onClickLinkedInButton = () => {
    ReactGa.event({
      category: "Button",
      action: "LinkedIn",
    });
    window.open("https://www.linkedin.com/in/dalson-tan/", "_blank");
  };

  const onClickGithubButton = () => {
    ReactGa.event({
      category: "Button",
      action: "Github",
    });
    window.open("https://github.com/dalsontws", "_blank");
  };

  return (
    <Flex
      as="nav"
      align="center"
      justify="space-between"
      wrap="wrap"
      w="100%"
      mb={4}
      p={4}
      bg={bgColor}
      top={0}
    >
      <Box>
        <Text fontSize="lg" fontWeight="bold">
          Did I Win TOTO?
        </Text>
      </Box>
      <Box display={{ base: "block", md: "none" }}></Box>
      <Spacer />
      <Box pl="2" pr="2">
        <Button
          as={IconButton}
          icon={<AiOutlineHome />}
          onClick={onClickHomeButton}
          aria-label="Home"
        />
      </Box>
      <Box pl="2" pr="2">
        <Button
          as={IconButton}
          icon={bgColor === "gray.50" ? <HiOutlineSun /> : <HiOutlineMoon />}
          onClick={toggleColorMode}
          aria-label="Toggle Theme"
        />
      </Box>
      <Box pl="2" pr="2">
        <Menu>
          <MenuButton
            as={IconButton}
            icon={<GiHamburgerMenu />}
            aria-label="Menu"
          ></MenuButton>
          <MenuList>
            <MenuItem
              as={Button}
              rightIcon={<VscFeedback />}
              onClick={() => navigate("/feedback")}
              aria-label="Feedback"
            >
              Feedback
            </MenuItem>
            <MenuItem
              as={Button}
              rightIcon={<AiFillGithub />}
              onClick={onClickGithubButton}
              aria-label="Github"
            >
              GitHub
            </MenuItem>
            <MenuItem
              as={Button}
              rightIcon={<AiFillLinkedin />}
              onClick={onClickLinkedInButton}
              aria-label="LinkedIn"
            >
              LinkedIn
            </MenuItem>
          </MenuList>
        </Menu>
      </Box>
    </Flex>
  );
};
